import React, { useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Col, Row, Button } from 'reactstrap';
import SurveyPatientForm from '../PublicForm/SurveyPatientForm';

const ModalSurveyPatients = ({ opened, closeModal, data }) => {

    return (
        <Modal
            open={opened}
            onClose={e => {
                closeModal();
            }}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ zIndex: 1000 }}
        >
            <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                <div>
                    <div className="card__title">
                        <h5 className="bold-text">Encuesta</h5>
                    </div>

                    <div style={{ maxHeight:'500px',overflowY:'scroll',overflowX:'hidden'}}>
                        <SurveyPatientForm surveyExistData={data} />
                    </div>

                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        style={{ marginTop: 10 }}
                        variant="contained"
                        className="btn btn-secondary btn-sm"
                        onClick={() => {
                            closeModal();
                        }}
                    >
                        Cerrar
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
export default ModalSurveyPatients;
